import React from 'react';

import { FlexCol } from '../FlexCol';
import { FlexRow } from '../FlexRow';
import { Label } from '../Label';

export const SearchModeSelector = ({ item, onChangeItem = () => {} }) => {
  if (!item) {
    return null;
  }
  return (
    <FlexRow className="rounded overflow-hidden border border-primary4 cursor-pointer">
      <FlexCol
        className={`px-5 w-24 items-center ${item.value ? 'bg-primary2 text-white' : ''}`}
        onClick={() => onChangeItem({ ...item, value: true })}
      >
        <Label label="Simple" className="text-base" />
      </FlexCol>
      <FlexCol
        className={`px-5 w-24 items-center ${!item.value ? 'bg-primary2 text-white' : ''}`}
        onClick={() => onChangeItem({ ...item, value: false })}
      >
        <Label label="Advanced" className="text-base" />
      </FlexCol>
    </FlexRow>
  );
};
